module.exports = __webpack_public_path__ + "media/Shapes/Shape1-25c828f5.svg";